import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StartComponent } from './start/start.component';
import { LoginFormComponent } from './start/login-form/login-form.component';
import { PwForgottenComponent } from './start/pw-forgotten/pw-forgotten.component';
import { PwSetnewComponent } from './start/pw-setnew/pw-setnew.component';
import { ConfirmEmailComponent } from './start/confirm-email/confirm-email.component';
import { RegisterComponent } from './start/register/register.component';
import { TwoFactorauthComponent } from './start/two-factorauth/two-factorauth.component';
import { PrivacyComponent } from './view/privacy/privacy.component';
import { ImprintComponent } from './view/imprint/imprint.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CookieService } from 'ngx-cookie-service';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { HttpConfigInterceptor } from './service/http.interceptor';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { AllcomponentsComponent } from './view/allcomponents/allcomponents.component';
import { IconModule } from './components/icon/icon.module';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { InputComponent } from './components/input/input.component';
import { SelectComponent } from './components/select/select.component';
import { BadgeComponent } from './components/badge/badge.component';
import { StartLogoComponent } from './components/start-logo/start-logo.component';
import { SegmentControlComponent } from './components/segment-control/segment-control.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DividerComponent } from './components/divider/divider.component';
import { TermsComponent } from './view/terms/terms.component';
import { CardComponent } from './components/card/card.component';
import { CardFooterComponent } from './components/card/card-footer/card-footer.component';
import { CardContentComponent } from './components/card/card-content/card-content.component';
import { NomobileuseComponent } from './view/nomobileuse/nomobileuse.component';
import { HomeComponent } from './home/home.component';
import { HomeHeaderComponent } from './home/home-header/home-header.component';
import { UseraccountComponent } from './home/useraccount/useraccount.component';
import { FaqComponent } from './view/faq/faq.component';
import { UserAvatarComponent } from './home/home-header/user-avatar/user-avatar.component';
import { SegmentControlItemComponent } from './components/segment-control/segment-control-item/segment-control-item.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { BasicSettingsComponent } from './home/useraccount/basic-settings/basic-settings.component';
import { TabControlComponent } from './components/tab-control/tab-control.component';
import { TabComponent } from './components/tab-control/tab/tab.component';
import { RangeControlComponent } from './components/range-control/range-control.component';
import { SelectBtnComponent } from './components/select-btn/select-btn.component';
import { BtnModule } from './components/btn/btn.module';
import { CategoryOverviewComponent } from './home/categories/category-overview/catergory-overview.component';
import { CategoryCreateEditComponent } from './home/categories/category-overview/category-create-edit/category-create-edit.component';
import { TagsComponent } from './home/tags/tags.component';
import { NewandedittagComponent } from './home/tags/newandedittag/newandedittag.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MenueComponent } from './components/menue/menue.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { CategoryItemComponent } from './home/categories/category-overview/category-item/category-item.component';
import { MatTreeModule } from '@angular/material/tree';
import { CategoriesComponent } from './home/categories/categories.component';
import { StreamsComponent } from './home/streams/streams.component';
import { AgentsComponent } from './home/streams/agents/agents.component';
import { NewandeditagentComponent } from './home/streams/newandeditagent/newandeditagent.component';
import { GetIndustryNameByIdPipe } from './pipes/get-industry-name-by-id.pipe';
import { TracksComponent } from './home/streams/tracks/tracks.component';
import { GetTagNameByIdPipe } from './pipes/get-tag-name-by-id.pipe';
import { ProgressComponent } from './components/progress/progress.component';
import { TrackComponent } from './home/streams/tracks/track/track.component';
import { EditStreamComponent } from './home/streams/edit-stream/edit-stream.component';
import { EditTrackComponent } from './home/streams/edit-track/edit-track.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EditStepComponent } from './home/streams/edit-step/edit-step.component';
import { GetStepTypeNameByIdPipe } from './pipes/get-step-type-name-by-id.pipe';
import { GetUsernameByIdPipe } from './pipes/get-username-by-id.pipe';
import { RagComponentComponent } from './home/streams/rag-component/rag-component.component';
import { CalcFileSizeInKbPipe } from './pipes/calc-file-size-in-kb.pipe';
import { BasicIdeaComponent } from './home/streams/stepcomponents/basic-idea/basic-idea.component';
import { UserTinderComponent } from './home/streams/stepcomponents/user-tinder/user-tinder.component';
import { IdeaTowerComponent } from './home/streams/stepcomponents/idea-tower/idea-tower.component';
import { ProblemShadowingComponent } from './home/streams/stepcomponents/problem-shadowing/problem-shadowing.component';
import { StepcomponentsComponent } from './home/streams/stepcomponents/stepcomponents.component';
import { VorlageComponent } from './home/streams/stepcomponents/vorlage/vorlage.component';
import { AiControlComponent } from './components/ai-control/ai-control.component';
import { AgentSelectComponent } from './components/agent-select/agent-select.component';
import { InstructionsComponent } from './home/streams/stepcomponents/instructions/instructions.component';
import { PrioritizeUserComponent } from './home/streams/stepcomponents/user-tinder/prioritize-user/prioritize-user.component';
import { SkippedUserComponent } from './home/streams/stepcomponents/user-tinder/skipped-user/skipped-user.component';
import { GeneratePromolinkComponent } from './home/streams/generate-promolink/generate-promolink.component';
import { SkipperComponent } from './components/skipper/skipper.component';
import { StreamReportComponent } from './home/stream-report/stream-report.component';
import { FlyingAgentsComponent } from './home/flying-agents/flying-agents.component';
import { CompaniesComponent } from './home/companies/companies.component';
import { UserComponent } from './home/user/user.component';
import { AddCompanyComponent } from './home/companies/add-company/add-company.component';
import { DetailsCompanyComponent } from './home/companies/details-company/details-company.component';
import { AddUserComponent } from './home/user/add-user/add-user.component';
import { DetailsUserComponent } from './home/user/details-user/details-user.component';
import { GetLocaldateByTimePipe } from './pipes/get-localdate-by-time.pipe';
import { GetCompanytypeByIdPipe } from './pipes/get-companytype-by-id.pipe';
import { ShowUserComponent } from './home/companies/show-user/show-user.component';
import { GenerateInviteLinkComponent } from './home/companies/generate-invite-link/generate-invite-link.component';
import { NewTracksComponent } from './home/streams/new-tracks/new-tracks.component';
import { CatSelectionComponent } from './home/streams/new-tracks/cat-selection/cat-selection.component';
import { AddGenericStreamComponent } from './home/streams/new-tracks/add-generic-stream/add-generic-stream.component';
import { AddGenericStepComponent } from './home/streams/new-tracks/add-generic-step/add-generic-step.component';
import { GetCategoryNameByIdPipe } from './pipes/get-category-name-by-id.pipe';
import { GenericStreamViewComponent } from './home/streams/new-tracks/generic-stream-view/generic-stream-view.component';
import { SelectConfigComponent } from './home/streams/new-tracks/generic-stream-view/select-config/select-config.component';
import { AddConfigComponent } from './home/streams/new-tracks/generic-stream-view/add-config/add-config.component';
import { GetStreamClosingTypeNameByIdPipe } from './pipes/get-stream-closing-type-name-by-id.pipe';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { UserReportComponent } from './home/user-report/user-report.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSortModule } from '@angular/material/sort';
import { EditConfigComponent } from './home/streams/new-tracks/generic-stream-view/edit-config/edit-config.component';
import { ConversationsComponent } from './home/conversations/conversations.component';
import { ConversationViewComponent } from './home/conversations/conversation-view/conversation-view.component';
import { FigmaExportsComponent } from './home/figma-exports/figma-exports.component';
import { AddRessourceComponent } from './home/figma-exports/add-ressource/add-ressource.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CompanyLogoComponent } from './home/companies/company-logo/company-logo.component';
import { GdprComponent } from './home/gdpr/gdpr.component';
import { ProcessingActivitiesComponent } from './home/gdpr/processing-activities/processing-activities.component';
import { AddProcessingActivitiesComponent } from './home/gdpr/add-processing-activities/add-processing-activities.component';
import { AddSreamResultComponent } from './home/streams/new-tracks/generic-stream-view/add-sream-result/add-sream-result.component';
import { StreamSummaryComponent } from './home/user-report/stream-summary/stream-summary.component';
import { GetStreamnameByConfigIdPipe } from './pipes/get-streamname-by-config-id.pipe';
import { PackageItemComponent } from './home/categories/category-overview/package-item/package-item.component';
import { TokenSummaryComponent } from './home/user-report/token-summary/token-summary.component';
import { EditUserGatesComponent } from './home/companies/edit-user-gates/edit-user-gates.component';
import { EditLoginFormsComponent } from './home/companies/edit-login-forms/edit-login-forms.component';
import { ConnectionDeletionRequiredComponent } from './home/figma-exports/connection-deletion-required/connection-deletion-required.component';

@NgModule({
    declarations: [
        AppComponent,
        StartComponent,
        LoginFormComponent,
        PwForgottenComponent,
        PwSetnewComponent,
        ConfirmEmailComponent,
        RegisterComponent,
        TwoFactorauthComponent,
        PrivacyComponent,
        ImprintComponent,
        SnackbarComponent,
        AllcomponentsComponent,
        CheckboxComponent,
        InputComponent,
        SelectComponent,
        BadgeComponent,
        StartLogoComponent,
        DividerComponent,
        TermsComponent,
        CardComponent,
        CardFooterComponent,
        CardContentComponent,
        NomobileuseComponent,
        HomeComponent,
        HomeHeaderComponent,
        UseraccountComponent,
        FaqComponent,
        UserAvatarComponent,
        SegmentControlComponent,
        SegmentControlItemComponent,
        SpinnerComponent,
        TextareaComponent,
        BasicSettingsComponent,
        TabControlComponent,
        TabComponent,
        RangeControlComponent,
        SelectBtnComponent,
        CategoryOverviewComponent,
        CategoryCreateEditComponent,
        TagsComponent,
        NewandedittagComponent,
        MenueComponent,
        DashboardComponent,
        CategoryItemComponent,
        CategoriesComponent,
        StreamsComponent,
        AgentsComponent,
        NewandeditagentComponent,
        GetIndustryNameByIdPipe,
        TracksComponent,
        GetTagNameByIdPipe,
        TrackComponent,
        EditStreamComponent,
        EditTrackComponent,
        ProgressComponent,
        EditStepComponent,
        GetStepTypeNameByIdPipe,
        GetUsernameByIdPipe,
        RagComponentComponent,
        CalcFileSizeInKbPipe,
        BasicIdeaComponent,
        UserTinderComponent,
        IdeaTowerComponent,
        ProblemShadowingComponent,
        StepcomponentsComponent,
        PackageItemComponent,
        VorlageComponent,
        AiControlComponent,
        AgentSelectComponent,
        InstructionsComponent,
        PrioritizeUserComponent,
        SkippedUserComponent,
        GeneratePromolinkComponent,
        SkipperComponent,
        StreamReportComponent,
        FlyingAgentsComponent,
        CompaniesComponent,
        UserComponent,
        AddCompanyComponent,
        DetailsCompanyComponent,
        AddUserComponent,
        DetailsUserComponent,
        GetLocaldateByTimePipe,
        GetCompanytypeByIdPipe,
        ShowUserComponent,
        GenerateInviteLinkComponent,
        NewTracksComponent,
        CatSelectionComponent,
        AddGenericStreamComponent,
        AddGenericStepComponent,
        GetCategoryNameByIdPipe,
        GenericStreamViewComponent,
        SelectConfigComponent,
        AddConfigComponent,
        GetStreamClosingTypeNameByIdPipe,
        UserReportComponent,
        EditConfigComponent,
        ConversationsComponent,
        ConversationViewComponent,
        FigmaExportsComponent,
        AddRessourceComponent,
        CompanyLogoComponent,
        GdprComponent,
        ProcessingActivitiesComponent,
        AddProcessingActivitiesComponent,
        AddSreamResultComponent,
        StreamSummaryComponent,
        GetStreamnameByConfigIdPipe,
        TokenSummaryComponent,
        EditUserGatesComponent,
        EditLoginFormsComponent,
        ConnectionDeletionRequiredComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        IconModule,
        BtnModule,
        MatDialogModule,
        DragDropModule,
        MatProgressSpinnerModule,
        FormsModule,
        HttpClientModule,
        CommonModule,
        MatExpansionModule,
        MatTreeModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
    ],
    providers: [
        CookieService,
        provideHttpClient(),
        provideAnimationsAsync(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true
        },
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} },
        provideAnimationsAsync('noop'),
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
